module.exports = __webpack_public_path__ + "img/mcabee-logo-new.9606ca55.jpg";